import { parseTsl } from '../tsl/core/parser';
import { tokenize } from '../tsl/core/tokenizer';
var inside = function (span, clause) { return span.start >= clause.span.start && span.end <= clause.span.end; };
/** Roles of the tokens of one condition or type clause, in token order. */
var clauseRoles = function (tokens, clause, registry) {
    var _a, _b, _c;
    if (clause.kind === 'fulltext') {
        return tokens.map(function () { return 'words'; });
    }
    var roles = [];
    var index = 0;
    if (registry.matchConnector(tokens[0]) === 'not') {
        roles.push('connector');
        index = 1;
    }
    var fill = function (role, count) {
        for (var step = 0; step < count && index < tokens.length; step += 1, index += 1) {
            roles.push(role);
        }
    };
    if (clause.kind === 'condition') {
        var field = registry.matchField(tokens, index);
        fill('field', (_a = field === null || field === void 0 ? void 0 : field.consumed) !== null && _a !== void 0 ? _a : 0);
        var relation = field ? registry.matchOperator(field.entry, tokens, index) : undefined;
        fill('relation', (_b = relation === null || relation === void 0 ? void 0 : relation.consumed) !== null && _b !== void 0 ? _b : 0);
    }
    else {
        var pseudo = registry.matchPseudoField(tokens, index);
        fill('field', (_c = pseudo === null || pseudo === void 0 ? void 0 : pseudo.consumed) !== null && _c !== void 0 ? _c : 0);
        fill('relation', registry.isEqualityToken(tokens[index]) ? 1 : 0);
    }
    fill('value', tokens.length - index);
    return roles;
};
/**
 * The query text split into runs of one role and one error state, for the backdrop
 * behind the textarea. Roles come from the same parser the search compiles with, so
 * a part is coloured as what it will be searched as, not as what it looks like.
 */
export var highlightRuns = function (text, registry, errorSpans) {
    var roles = new Array(text.length).fill(undefined);
    var tokens = tokenize(text);
    var clauses = parseTsl(text, registry).clauses;
    var claimed = new Set();
    clauses.forEach(function (clause) {
        var own = tokens.filter(function (token) { return inside(token.span, clause); });
        own.forEach(function (token) { return claimed.add(token); });
        clauseRoles(own, clause, registry).forEach(function (role, index) {
            roles.fill(role, own[index].span.start, own[index].span.end);
        });
    });
    tokens.filter(function (token) { return !claimed.has(token); }).forEach(function (token) {
        var connector = registry.matchConnector(token) !== undefined
            || (token.type === 'symbol' && (token.value === '(' || token.value === ')'));
        if (connector) {
            roles.fill('connector', token.span.start, token.span.end);
        }
    });
    var errors = new Array(text.length).fill(false);
    errorSpans.forEach(function (span) {
        // An empty span (a missing value at the end) still gets one visible cell.
        errors.fill(true, span.start, Math.min(Math.max(span.end, span.start + 1), text.length));
    });
    var runs = [];
    // split(''), not spread: the spans are UTF-16 offsets, and so are these indexes.
    text.split('').forEach(function (char, index) {
        var last = runs[runs.length - 1];
        if (last && last.role === roles[index] && last.error === errors[index]) {
            last.text += char;
        }
        else {
            runs.push({ text: char, role: roles[index], error: errors[index] });
        }
    });
    return runs;
};
